var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9941_8368)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9941_8368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 43C33.2025 43 43.5 32.7025 43.5 20C43.5 7.29745 33.2025 -3 20.5 -3C7.79745 -3 -2.5 7.29745 -2.5 20C-2.5 32.7025 7.79745 43 20.5 43Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 20C43.5 10.8814 38.1934 3.00248 30.5 -0.717773V40.7177C38.1934 36.9976 43.5 29.1186 43.5 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.5 20C-2.5 29.1186 2.80662 36.9976 10.5 40.7178V-0.717773C2.80662 3.00248 -2.5 10.8814 -2.5 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23L28.5 21L26.5 20V18L22.5 20L24.5 16H22.5L20.5 13L18.5 16H16.5L18.5 20L14.5 18V20L12.5 21L16.5 23L15.5 25H19.5V28H21.5V25H25.5L24.5 23Z",
    fill: "#D80027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9941_8368"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9941_8368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.5 20C-2.5 7.29745 7.79745 -3 20.5 -3C33.2025 -3 43.5 7.29745 43.5 20C43.5 32.7025 33.2025 43 20.5 43C7.79745 43 -2.5 32.7025 -2.5 20Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaFlag);
export default __webpack_public_path__ + "static/media/ca-flag.b95619bad4e33f47a8da556c744b917a.svg";
export { ForwardRef as ReactComponent };